import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../img/logo.png";

const MainHeader = () => {
  return <header className="container">
      <div className="kl-admin-header">
        <button onClick={() => window.history.back()} className="p-0 kl-back-button">
          <FontAwesomeIcon icon={faArrowLeft} className="kl-icon-arrow" />
        </button>
        <div className="kl-logo-contab">
          <img src={logo} alt="logo" />
        </div>
      </div>
    </header>;
};

export default MainHeader;
